export default __webpack_public_path__ + "a73c2fcb6ad3b32904376af253d2831f.svg";